import { Outlet } from 'react-router-dom';

import { useAuth } from '@saas-kit/lib';
import { TenantSwitcher, WorkspaceShell, type BrandInfo } from '@saas-kit/ui/shell';

import { ImpersonationBanner } from './ImpersonationBanner';
import {
  SubscriptionGateBanner,
  useSubscriptionGateEvent,
} from './SubscriptionGateBanner';
import { tenantNav } from './nav';

const TENANT_BRAND: BrandInfo = {
  initial: 'D',
  name: 'Donum Queues',
  subtitleKey: 'nav.tenant_subtitle',
};

export function AppShell(): JSX.Element {
  const impersonating = useAuth((s) => s.impersonation.active);
  const selectedTenant = useAuth((s) => s.selectedTenant);
  const brand: BrandInfo = {
    initial: (selectedTenant?.name ?? TENANT_BRAND.name).charAt(0).toUpperCase(),
    name: selectedTenant?.name ?? TENANT_BRAND.name,
    subtitleKey: 'nav.tenant_subtitle',
  };

  const gate = useSubscriptionGateEvent();

  let topBanner: JSX.Element | null = null;
  if (gate.event) {
    topBanner = (
      <SubscriptionGateBanner event={gate.event} onDismiss={gate.dismiss} />
    );
  } else if (impersonating) {
    topBanner = <ImpersonationBanner />;
  }

  return (
    <WorkspaceShell
      brand={brand}
      brandTo="/"
      nav={tenantNav}
      profilePath="/profile"
      notificationsTo="/notifications"
      preferencesPath="/notifications?tab=preferences"
      signOutRedirect="/auth/login"
      collapsedKey="saas-kit.tenant.sidebar.collapsed"
      tenantSwitcher={<TenantSwitcher />}
      {...(topBanner ? { topBanner } : {})}
    >
      <Outlet />
    </WorkspaceShell>
  );
}
